<template>
  <blank-view>
    <div :slot="'action'" style="display:flex;justify-content: space-between">
      <div>
        <a-button type="primary" @click="() => addNew()" style="margin-right: 8px;">
          新建
        </a-button>
        <a-popconfirm
          :title="$t('delete_tips')"
          :disabled="selectedRowKeys.length === 0"
          @confirm="() => deleteData()"
        >
          <a-button type="danger" :disabled="selectedRowKeys.length === 0">
            {{ $t('delete') }}
          </a-button>
        </a-popconfirm>
      </div>
    </div>
    <div id="inner">
      <ml-table
        :columns="columns"
        :dataSource="dataSource"
        rowKey="id"
        bordered
        :scroll="{ y: scrollY, x: 900 }"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <template slot="content" slot-scope="text">
          <div
            v-html="text"
            :title="text"
            style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
          ></div>
        </template>
      </ml-table>
      <a-pagination
        style="position:absolute;bottom: 4px;right: 4px"
        :show-total="(total) => `${showTotal(total)}`"
        :current="pagination.current"
        :total="pagination.total"
        :pageSize="pagination.pageSize"
        @change="handleTableChange"
      />
    </div>
    <add-edit
      :type="pusbType"
      :visible="addEditVisible"
      :rowConetent="selectRow"
      @cancel="(value) => cancelAddEdit(value)"
    ></add-edit>
  </blank-view>
</template>

<script>
import { PublishRecordServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const prsp = new PublishRecordServiceProxy()

import AddEdit from './components/AddEdit.vue'
import dayjs from 'dayjs'

export default {
  components: {
    AddEdit
  },
  data() {
    return {
      columns: [
        {
          title: this.$t('page_material_action'),
          dataIndex: 'id',
          key: 'id',
          width: 150,
          customRender: (sort, _record) => {
            return (
              <div>
                <a class="table-span" onClick={() => this.pubilshRecord(_record)}>
                  发布
                </a>
                <a-divider type="vertical" />
                <a class="table-span" onClick={() => this.editRecord(_record)}>
                  {this.$t('edit')}
                </a>
              </div>
            )
          }
        },
        {
          title: '版本',
          dataIndex: 'version',
          key: 'version',
          ellipsis: true,
          width: 150
        },
        {
          title: '更新内容',
          dataIndex: 'content',
          key: 'content',
          ellipsis: true,
          width: 200,
          scopedSlots: { customRender: 'content' }
        },
        {
          title: '发布日期',
          dataIndex: 'publishDate',
          key: 'publishDate',
          ellipsis: true,
          width: 200
        },
        {
          title: '发布状态',
          dataIndex: 'publishStatus',
          key: 'publishStatus',
          width: 200,
          customRender: (value) => {
            return <span>{value == 0 ? '未发布' : '已发布'}</span>
          }
        }
      ],
      selectedRowKeys: [],
      scrollY: 0,
      dataSource: [],
      pagination: {
        current: 1,
        total: 0,
        pageSize: 30
      },
      addEditVisible: false,
      pusbType: '',
      selectRow: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.dataSource = []
      const res = await prsp.list(this.pagination.current, this.pagination.pageSize)
      if (res.total) {
        this.dataSource = res.records.map((res) => {
          const value = { ...res }
          value.publishDate = dayjs(res.publishDate).format('YYYY-MM-DD')
          return value
        })
      }
      this.pagination.total = res.total
    },
    handleTableChange(value) {
      this.pagination.current = value
      this.getList()
    },
    onSelectChange(value) {
      this.selectedRowKeys = value
    },
    async deleteData() {
      await prsp.remove(this.selectedRowKeys)
      this.$message.success('删除成功')
      this.getList()
    },
    addNew() {
      this.pusbType = '1'
      this.selectRow = {}
      this.addEditVisible = true
    },
    cancelAddEdit(value) {
      if (value) {
        this.getList()
      }
      this.pusbType = ''
      this.addEditVisible = false
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    pubilshRecord(record) {
      this.pusbType = '3'
      console.log(record)
      this.selectRow = record
      this.addEditVisible = true
    },
    editRecord(record) {
      this.pusbType = '2'
      console.log(record)
      this.selectRow = record
      this.addEditVisible = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
